import { type FC } from 'react';
import {
  StackSimple
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconStackSimpleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconStackSimple: FC<UiIconStackSimpleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={StackSimple}
      {...props}
    />
  );
};
